import React, { useState, useEffect } from 'react';
import {
  Box, Container, Paper, Grid, Typography, TextField, Divider,
  Checkbox, FormControlLabel, FormGroup, Button, Stack, Snackbar
} from "@mui/material";
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { useParams } from "react-router-dom";
import MuiAlert from '@mui/material/Alert';
import dayjs from "dayjs";
import logo from '../img/logo-llantas.png';
import imgCamion from '../img/Camion.jpg';
import imgBri from '../img/bridgestone.jpg';
import { useNavigate } from 'react-router-dom';

const OrdenServicioUnidadMovil2 = () => {
  const navigate = useNavigate();
  const [folio, setFolio] = useState("0");
  const [sucursal, setSucursal] = useState("");

  const { idCita } = useParams();
  const [cliente, setCliente] = useState({});

  const [camion, setCamion] = useState({
    vehiculo: "",
    modelo: "",
    color: "",
    placas: "",
    unidad: "",
    llantasTipo: "",
    llantasMedida: 0,
    rinesTipo: "",
    rinesMedida: 0,
    amortDelantes: 0,
    amortTraseros: 0,
  });
  const tipo = "Unidad Movil " + sucursal;
  const [recepcion, setRecepcion] = useState(dayjs());
  const [entrega, setEntrega] = useState(dayjs());
  const [observacion, setObservacion] = useState('');
  const [comentario, setComentario] = useState('');
  const [condicion, setCondicion] = useState('');
  const [factura, setFactura] = useState('');
  const [autoriSalida, setAutoriSalida] = useState('');
  const [jefeServicio, setJefeServicio] = useState('');
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');

  const [servicios, setServicios] = useState({
    diagnostico: false,
    alineacionDelantera: false,
    alineacionTrasera: false,
    correccionEje: false,
    correccionCaster: false,
    correccionCamber: false,
    balanceo: false,
    suspension: false,
    rotacion: false,
    plomos: false,
    montaje: false,
    ponchada: false,
    valvulas: false,
    lainas: 0,
    cuna: 0,
    vitalizadas: 0,
    semaforo: false
  });

  const handleServicioChange = (key) => (e) => {
    setServicios({ ...servicios, [key]: e.target.checked });
  };

  const handleInputChange = (field) => (e) => {
    setCamion({ ...camion, [field]: e.target.value });
  };

  const handleServicioInputChange = (key) => (e) => {
    setServicios({ ...servicios, [key]: e.target.value });
  };


  const handleSubmit = () => {
    const payload = {
      folio,
      idCita,
      sucursal,
      cliente,
      camion,
      recepcion: recepcion.toISOString(),
      entrega: entrega.toISOString(),
      servicios,
      observacion,
      condicion,
      factura,
      jefeServicio,
      autoriSalida,
      comentario,
      tipo
    };

    fetch('https://bibliotecadlago.com/php/Backend/guardarDetalleCitaCC.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then(res => res.json())
      .then(data => {
        console.log("Respuesta del servidor:", data);
        showNotification('✅ Cita registrada correctamente.', 'success');
        navigate('/servicios');
      })
      .catch(error => {
        showNotification('❌ ' + error, 'error');
      });
  };

  const showNotification = (message, severity = 'success') => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setOpenSnackbar(true);
    setAutoriSalida('')
    setSucursal('')
  };

  useEffect(() => {
    fetch('https://bibliotecadlago.com/php/Backend/obtenerFolio.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
    })
      .then(res => res.json())
      .then(data => {
        setFolio(data[0]?.ultimo_id)
      });
    fetch('https://bibliotecadlago.com/php/Backend/infoUsuario.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ IdCita: idCita }),
    })
      .then(res => res.json())
      .then(data => {
        const clienteData = {
          facturar: data[0]?.Empresa || "",
          rfc: data[0]?.rfc || "",
          domicilio: data[0]?.Domicilio || "",
          ciudad: data[0]?.Ciudad || "",
          solicitado: data[0]?.Solicitado || "",
        };
        setCliente(clienteData);
      });
  }, [idCita]);

  return (
    <Container maxWidth="md" sx={{ py: 3 }}>
      <Paper elevation={3} sx={{ p: { xs: 2, sm: 3 }, borderRadius: 3 }}>
        {/* Encabezado */}
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={8}>
              <Typography variant="h5" sx={{ fontWeight: 800 }}>EQUIPO PORTATIL DE ALINEACION</Typography>
              <Stack direction="row" spacing={2} sx={{ mt: 1 }}>
                <Box component="img" src={logo} alt="Logo" sx={{ height: 35, width: 180 }} />
                <Box component="img" src={imgBri} alt="Bridgestone" sx={{ height: 38, width: 110 }} />
              </Stack>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Box sx={{ border: "2px solid", borderColor: "grey.800", borderRadius: 2, p: 1.5, textAlign: "center" }}>
                <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>ORDEN DE SERVICIO</Typography>
                <Typography variant="h4" sx={{ fontWeight: 900 }}>{folio}</Typography>
              </Box>
            </Grid>
          </Grid>

          {/* Datos del Cliente */}
          <Divider sx={{ my: 2, width: "100%" }} />
          <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>DATOS DEL CLIENTE</Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}><Typography><strong>FACTURAR:</strong> {cliente.facturar}</Typography></Grid>
            <Grid item xs={12} sm={6}><Typography><strong>Solicitado por:</strong> {cliente.solicitado}</Typography></Grid>
            <Grid item xs={12} sm={6}><Typography><strong>RFC:</strong> {cliente.rfc}</Typography></Grid>
            <Grid item xs={12} sm={6}><Typography><strong>DOMICILIO:</strong> {cliente.domicilio}</Typography></Grid>
            <Grid item xs={12} sm={6}><Typography><strong>CIUDAD:</strong> {cliente.ciudad}</Typography></Grid>
          </Grid>

          {/* Datos del vehículo */}
          <Divider sx={{ my: 2 }} />
          <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>DATOS DEL VEHÍCULO</Typography>
          <Grid item xs={12}>
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                gap: 2,
                alignItems: "flex-start",
              }}
            >
              <Box
                component="img"
                src={imgCamion}
                alt="Camión"
                sx={{
                  width: { xs: "100%", md: 250 },
                  height: "auto",
                  borderRadius: 2,
                  objectFit: "cover",
                  flexShrink: 0,
                }}
              />

              <Box sx={{ flexGrow: 1 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <TextField label="Vehículo" fullWidth size="small" value={camion.vehiculo} onChange={handleInputChange("vehiculo")} />
                  </Grid>
                  <Grid item xs={6} sm={3}>
                    <TextField label="Modelo" fullWidth size="small" value={camion.modelo} onChange={handleInputChange("modelo")} />
                  </Grid>
                  <Grid item xs={6} sm={3}>
                    <TextField label="Color" fullWidth size="small" value={camion.color} onChange={handleInputChange("color")} />
                  </Grid>
                  <Grid item xs={6} sm={3}>
                    <TextField label="Placas" fullWidth size="small" value={camion.placas} onChange={handleInputChange("placas")} />
                  </Grid>
                  <Grid item xs={6} sm={3}>
                    <TextField label="Unidad No." fullWidth size="small" value={camion.unidad} onChange={handleInputChange("unidad")} />
                  </Grid>
                </Grid>
                <br />
                <Grid container spacing={2}>
                  <Grid item xs={6} sm={3}>
                    <DateTimePicker label="Recepión" value={recepcion} onChange={(val) => setRecepcion(val)} />
                  </Grid>
                  <Grid item xs={6} sm={3}>
                    <DateTimePicker label="Entrega" value={entrega} onChange={(val) => setEntrega(val)} />
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </Grid>
          {/* Servicios */}
          <Divider sx={{ my: 2 }} />
          <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>SERVICIO GENERAL</Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <FormGroup>
                <FormControlLabel control={<Checkbox checked={servicios.diagnostico} onChange={handleServicioChange("diagnostico")} />} label="Diagnóstico" />
                <FormControlLabel control={<Checkbox checked={servicios.alineacionDelantera} onChange={handleServicioChange("alineacionDelantera")} />} label="Alineación delantera" />
                <FormControlLabel control={<Checkbox checked={servicios.alineacionTrasera} onChange={handleServicioChange("alineacionTrasera")} />} label="Alineación trasera 2 ejes" />
                <FormControlLabel control={<Checkbox checked={servicios.correccionEje} onChange={handleServicioChange("semaforo")} />} label="Semaforo" />
              </FormGroup>
            </Grid>

            <Grid item xs={12} sm={4}>
              <FormGroup>
                <FormControlLabel control={<Checkbox checked={servicios.balanceo} onChange={handleServicioChange("balanceo")} />} label="Balanceo" />
                <FormControlLabel control={<Checkbox checked={servicios.plomos} onChange={handleServicioChange("plomos")} />} label="Plomos" />
                <FormControlLabel control={<Checkbox checked={servicios.montaje} onChange={handleServicioChange("montaje")} />} label="Montaje" />
                <FormControlLabel control={<Checkbox checked={servicios.ponchada} onChange={handleServicioChange("ponchada")} />} label="Ponchada" />
                <FormControlLabel control={<Checkbox checked={servicios.valvulas} onChange={handleServicioChange("valvulas")} />} label="Válvulas" />
              </FormGroup>
            </Grid>

            <Grid item xs={12} sm={4}>
              <Stack spacing={2}>
                <TextField label="Vitalizadas" type="number" fullWidth value={servicios.vitalizadas} onChange={handleServicioInputChange("vitalizadas")} />
              </Stack>
            </Grid>
          </Grid>

          {/* Observaciones */}
          <Divider sx={{ my: 2 }} />
          <TextField fullWidth label="OBSERVACIONES" multiline minRows={3} variant="outlined" value={observacion} onChange={(event) => setObservacion(event.target.value)} />

          <Divider sx={{ my: 2 }} />
          <TextField fullWidth label="COMENTARIOS" multiline minRows={2} variant="outlined" value={comentario} onChange={(event) => setComentario(event.target.value)} />


        </Box>
        {/* Condiciones a la derecha */}
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
          <Box sx={{ textAlign: "right" }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1 }}>
              Condiciones
            </Typography>
            <FormGroup row sx={{ justifyContent: "flex-end" }}>
              {["Contado", "Crédito"].map((label) => (
                <FormControlLabel
                  key={label}
                  control={
                    <Checkbox
                      checked={condicion === label}
                      onChange={() => setCondicion(label)}
                    />
                  }
                  label={label}
                />
              ))}
            </FormGroup>

          </Box>
        </Box>

        {/* Firmas centradas */}
        <Grid container spacing={2} justifyContent="center" sx={{ mt: 2 }}>
          <Grid item xs={12} sm={6}>
            <TextField fullWidth label="Atendido con facturas Nos" size="small" value={factura} onChange={(event) => setFactura(event.target.value)} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField fullWidth label="Alineador" size="small" value={jefeServicio} onChange={(event) => setJefeServicio(event.target.value)} />
          </Grid>
        </Grid>

        {/* Botones */}
        <Stack direction="row" spacing={2} sx={{ mt: 3 }} justifyContent="flex-end">
          <Button
            variant="contained"
            onClick={() => {
              navigate(`/servicios`);
            }}
            sx={{ backgroundColor: '#1976d2' }}
          >
            Regresar a Servicios
          </Button>
          <Button variant="contained" onClick={handleSubmit}>Guardar</Button>
          <Button variant="contained" onClick={() => window.print()}>Imprimir</Button>
        </Stack>
        <Typography variant="caption" color="text.secondary" sx={{ mt: 2 }}>
          NOTA: Solicitar la facturacion a la sucursal correspondiete.
        </Typography>
        <Typography variant="caption" color="text.secondary" sx={{ mt: 2 }}>
          En cumplimiento con la Ley Federal de Protección de Datos Personales en Posesión de los
          Particulares, se le informa que los datos personales proporcionados estarán sujetos a
          nuestro Aviso de Privacidad.
        </Typography>
      </Paper>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={() => setOpenSnackbar(false)}
          severity={snackbarSeverity}
          sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </Container>
  );
};

export default OrdenServicioUnidadMovil2;
